'use strict';

var competizeBacklinks = require('./competizeBacklinks');
var competizeSharedCount = require('./competizeSharedCount');
var initCompTabs = require('./initCompTabs');

function competizeAll (isPdf) {
  if (isPdf == null) {
    isPdf = false;
  }

  if (!isPdf) {
    competizeSharedCount();
  }

  competizeBacklinks('backlinks_counter');
  competizeBacklinks('backlinks_ref_domains');

  if (!isPdf) {
    return initCompTabs();
  }
}

module.exports = competizeAll;
